"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTaxIdTemplate = buildTaxIdTemplate;
var entities_1 = require("@common/entities");
function buildTaxIdTemplate(config) {
    return {
        name: config.name,
        label: config.label,
        customType: config.idType,
        taxIdTypeId: config.taxIdTypeId,
        elementType: entities_1.SectionElementType.Block,
        fields: [
            {
                customType: entities_1.FieldType.Text,
                enabled: true,
                label: config.label,
                name: entities_1.IdTypeFields.value.name,
                required: false,
                sequence: 1,
                type: entities_1.FieldType.Text,
            },
            {
                customType: entities_1.FieldType.Checkbox,
                enabled: false,
                label: config.dontHaveLabel,
                name: config.dontHaveFieldName,
                required: false,
                sequence: 5,
                type: entities_1.FieldType.Checkbox,
            },
        ],
    };
}
